/* eslint-disable no-console */
import axios from "axios";
import { getToken } from "../auth-helper";
import { AppConfig } from "../config/app-config";

// async function wait(ms: number) {
//   return new Promise(resolve => {
//     setTimeout(() => resolve(), ms);
//   });
// }

export const BaseApi = {
  list: (resourceKey: string) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const token = getToken();
    // console.log(`BaseApi token: ${token}`);
    return axios.get(`${apiBase}/${resourceKey}/`, {
      headers: { Authorization: `JWT ${token}` },
    });
  },
  create: (resourceKey: string, params: any) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const token = getToken();
    // console.log(`BaseApi token: ${token}`);
    const url = `${apiBase}/${resourceKey}/`;
    // console.log(`BaseApi url: ${url}`);
    return axios.post(url, params, {
      headers: {
        Authorization: `JWT ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
  retrieve: (resourceKey: string, pk: number) => {
    const apiBase = AppConfig.get("apiBase");
    const token = getToken();
    return axios.get(`${apiBase}/${resourceKey}/${pk}/`, {
      headers: { Authorization: `JWT ${token}` },
    });
  },
  update: (resourceKey: string, pk: number, params: any) => {
    const apiBase = AppConfig.get("apiBase");
    // console.log(`BaseApi apiBase: ${apiBase}`);
    const token = getToken();
    // console.log(`BaseApi token: ${token}`);
    const url = `${apiBase}/${resourceKey}/${pk}/`;
    // console.log(`BaseApi url: ${url}`);
    return axios.put(url, params, {
      headers: {
        Authorization: `JWT ${token}`,
        "Content-Type": "application/json",
      },
    });
  },
  destroy: (resourceKey: string, pk: number) => {
    const apiBase = AppConfig.get("apiBase");
    const token = getToken();
    return axios.delete(`${apiBase}/${resourceKey}/${pk}/`, {
      headers: { Authorization: `JWT ${token}` },
    });
  },

  // 再帰呼び出しを前提とした呼び出し
  recursive: (
    url: string,
    proc: (result: any, options: any) => string | null,
    delay?: number,
    options?: any
  ) => {
    const delayVal = delay || 0;

    return new Promise(resolve => {
      // ループ処理（再帰的に呼び出し）
      const token = getToken();
      async function loop(nextUrl: string): Promise<any> {
        const result = await axios.get(nextUrl, {
          headers: { Authorization: `JWT ${token}` },
        });
        const newNextUrl = proc(result, options);

        // TODO: 一旦ここで指定数秒待ちたい
        if (newNextUrl) {
          // 次のURL
          resolve(loop(newNextUrl));
        }
        // 抜ける（外側のPromiseのresolve判定を実行）
        resolve("success");
      }
      // 初回実行
      loop(url);
    });
  },
};
